import { render, staticRenderFns } from "./SortAlphabeticalDescending.vue?vue&type=template&id=30be675c"
import script from "./SortAlphabeticalDescending.vue?vue&type=script&lang=js"
export * from "./SortAlphabeticalDescending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports